import { LinearProgress } from "@mui/material";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { useFindDeviceByIdDevicesIdGetQuery } from "api";
import { ErrorPage, NoDataPage } from "components/pages";

import { DeviceForm } from "./forms/DeviceForm";

export const DeviceEditPage = () => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();

  const {
    data: deviceData,
    isLoading,
    isError,
    refetch,
  } = useFindDeviceByIdDevicesIdGetQuery({ id: id ?? "" }, { skip: !id });

  if (isLoading) {
    return <LinearProgress variant={"indeterminate"} />;
  }

  if (isError) {
    return (
      <ErrorPage
        title={t("Failed to load data")}
        buttonText={t("Try again")}
        buttonOnClick={refetch}
      />
    );
  }

  const device = deviceData?.data;

  if (!device || device.type === "generic") {
    return <NoDataPage title={t("no_device_found")} />;
  }

  return <DeviceForm device={device} />;
};
